import dayjs from "dayjs";

const APP_ENVIRONMENT = process.env.GATSBY_APP_ENVIRONMENT || "dev";
// TODO: Externalize this configuration
const API_GATEWAY_ID =
  APP_ENVIRONMENT === "prod"
    ? "fcfcg7gyl1"
    : APP_ENVIRONMENT === "stage"
    ? "g9yl70gkjh"
    : "kowfh23cfd";
const API_GATWAY_URL = `https://${API_GATEWAY_ID}.execute-api.us-east-1.amazonaws.com/v1/getPresignedUrl`;

// Parses a data URL into { blob, mimeType, extension }.
// Reads the actual MIME type from the data URL header (e.g. "data:image/webp;base64,...")
// so we don't mislabel WebP thumbnails as PNG when uploading to S3.
const dataUrlToBlob = b64Data => {
  const match = b64Data?.match(/^data:([^;]+);base64,(.*)$/);
  const mimeType = match?.[1] || "image/png";
  const payload = match?.[2] || b64Data?.split(",")[1] || "";
  const binary = atob(payload);
  const array = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    array[i] = binary.charCodeAt(i);
  }
  const extension = mimeType.split("/")[1] || "png";
  return { blob: new Blob([array], { type: mimeType }), mimeType, extension };
};

const blobToFile = (theBlob, fileName) => {
  theBlob.lastModifiedDate = new Date();
  theBlob.name = fileName;
  return theBlob;
};

export const s3uploader = async (
  files,
  filePath,
  handleLoader,
  locationId,
  user,
  lead,
  suffixSplitter,
  index = 0,
  isThumbnail = false
) => {
  let fileObj = files;

  if (isThumbnail) {
    // The data URL header tells us the actual format (image/webp now, image/png
    // for older callers). Use it so the S3 object Content-Type and extension match
    // the binary payload.
    const { blob, extension } = dataUrlToBlob(files[0]);
    const fileName = `1-thumbnail.${extension}`;
    fileObj = blobToFile(blob, fileName);
  }

  try {
    handleLoader(true);
    const filename = fileObj.name;
    const fileExtension = filename.split(".").pop();
    const originalName = filename.split(".")[0]; // Extract name without extension
    const fileName = `${originalName}_${dayjs().utc().format("HHmmss")}`; // Add only time HH:mm:ss
    const fileFolder =
      fileObj?.type?.split("/")[0] === "image"
        ? "images"
        : fileObj.type.split("/")[0] === "video"
        ? "videos"
        : "documents";

    const apiUrl = `${API_GATWAY_URL}?filePath=${filePath}&fileName=${fileName}&fileExtension=${fileExtension}&fileFolder=${fileFolder}&contentType=${fileObj.type}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    });
    const data = await response.json();

    // PUT request: upload file to S3
    await fetch(data.uploadURL, {
      method: "PUT",
      headers: {
        "Content-Type": fileObj.type,
      },
      body: fileObj,
    });

    handleLoader(false);

    return {
      url: data?.downloadUrl?.split("?")[0],
      filename: `${fileObj.name.split(".")[0]}.${fileExtension}`,
    };
  } catch (err) {
    console.log("Error in s3uploader", err.message);
    handleLoader(false);
  }
};
export const s3UploaderUpdated = async (files, locationId, userId, leadId, setLoaderFn) => {
  try {
    setLoaderFn(true);
    const fileUploads = files.map((file, index) => {
      const filename = file.name;
      const fileExtension = filename.split(".").pop();
      const originalName = filename.split(".")[0]; // Extract name without extension
      const fileType = file.type.split("/")[0];
      const fileFolder = ["image", "video", "audio"].includes(fileType)
        ? `${fileType}s`
        : "documents";

      const fileName = `${originalName}_${dayjs()
        .utc()
        .format("HHmmss")}_${index}.${fileExtension}`;

      return {
        file,
        fileName,
        fileFolder,
        fileExtension,
        contentType: file.type,
      };
    });

    const uploadPromises = fileUploads.map(async fileUpload => {
      const apiUrl = `${API_GATWAY_URL}?filePath=${process.env.GATSBY_S3_BUCKET}&fileName=${fileUpload.fileName}&fileExtension=${fileUpload.fileExtension}&fileFolder=${fileUpload.fileFolder}&contentType=${fileUpload.contentType}`;

      const response = await fetch(apiUrl, {
        method: "GET",
        mode: "cors",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      const data = await response.json();

      await fetch(data.uploadURL, {
        method: "PUT",
        headers: {
          "Content-Type": fileUpload.contentType,
        },
        body: fileUpload.file,
      });

      return {
        url: data.downloadUrl.split("?")[0],
        filename: fileUpload.fileName,
      };
    });

    const results = await Promise.all(uploadPromises);
    setLoaderFn(false);
    return results;
  } catch (err) {
    console.error("Error in s3uploader", err.message);
    throw err;
  }
};
